<script setup>
import { ref, onMounted, computed, nextTick, onUnmounted } from "vue";
import { useScrollStore } from "@/stores/storeScroll";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { useQuizEmojiStore } from "@/stores/storeQuizEmoji";
import { useModals } from "@/utils/useModals";
import { sendMetrik } from '@/utils/metrika'
import { sendAdriver } from '@/utils/metrika';
import QuizEmoji from "@/components/quize/QuizEmoji.vue";
import QuizEndGameEmoji from "@/components/quize/QuizEndGameEmoji.vue";
import QuizWelcomeScreen from "@/components/quize/QuizWelcomeScreen.vue";


const storeScroll = useScrollStore();
const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();
const storeQuizEmoji = useQuizEmojiStore();
const { openModal } = useModals();


onMounted( async() => {
	
	
});
onUnmounted(() => {
})
</script>
<template>
	<section class="quiz"  :style="{ paddingTop: storeScroll.paddingTop }">
		<TransitionGroup>

			<QuizWelcomeScreen v-if="storeQuizEmoji.isShowWelcomScreen" class="--emoji">				
				<template #nameGame>Шедевры в эмодзи</template>
				<template #descGame>
					<p class="quiz__text">Приготовьтесь проверить свои знания в мире изобразительного искусства!</p>
					<p class="quiz__text">Вас ждут захватывающие вопросы, и ваша задача – отгадать картины по эмодзи.</p>
				</template>
				<template #listGame>
					<ul>
						<li>1. Разгадывайте названия знаменитых картин по эмодзи</li>
						<li>2. Ответьте на 10 вопросов верно в отведенное на игру время (3 минуты)</li>
					</ul>
				</template>
				<template #rulesGame>
					<p>
						Ответьте на 10 вопросов, получайте шанс стать обладателем эксклюзивных призов.<br>
						Полагайтесь на свою внимательность, демонстрируйте знания и стремитесь к победе! <br> 
						Готовы? Нажимайте <span>«СТАРТ»</span>
					</p>
				</template>
				<template #btnStartGame>
					<button @click="storeQuizEmoji.startGame(), sendMetrik('reachGoal', 'Emojis_start')" class="btn --blue">Старт</button>
				</template>
			</QuizWelcomeScreen>
<!-- storeQuizEmoji.isShowGame -->
			<QuizEmoji v-if="storeQuizEmoji.isShowGame" />

			<QuizEndGameEmoji v-if="storeQuizEmoji.isShowEndGame" />
			
		</TransitionGroup>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz {
	background-image: url("@/assets/img/main/main_bg.webp");
	background-repeat: no-repeat;
	background-position: center; /* x y*/
	background-size: cover; /* w h*/
	@media (max-width: vars.$xx) {
		background-image: url("@/assets/img/main/main_bg_mobile.webp");
	}
}
.v-enter-active,
.v-leave-active {
	transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateY(10px);
}
</style>
